import { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { SortOrder, listFiltersService, ListTableSort } from "sprint-common-web";

export interface WatermarkRuleListingFilters {
    page: number;
    pageSize: number;
    sortBy: string;
    sortOrder: SortOrder;
    airlineName?: string;
}

const defaultFilters: WatermarkRuleListingFilters = {
    page: 1,
    pageSize: 50,
    sortBy: "airlineName",
    sortOrder: "asc",
    airlineName: ""
};

export const useWatermarkRuleListingFilters = () => {
    const filtersService = useMemo(() => listFiltersService<WatermarkRuleListingFilters>(defaultFilters), []);
    const location = useLocation();
    const history = useHistory();

    const [filters, setFilters] = useState<WatermarkRuleListingFilters>(() =>
        filtersService.getSavedFilters(location.search)
    );

    useEffect(() => {
        filtersService.saveFilters(location.pathname, history, filters);
    }, [location.pathname, history, filters]);

    const setSort = (sort: ListTableSort) => {
        setFilters((prevFilters: WatermarkRuleListingFilters) => ({
            ...prevFilters,
            sortBy: sort.by,
            sortOrder: sort.order,
            page: 1
        }));
    };

    const setPage = (page: number) => {
        setFilters((prevFilters: WatermarkRuleListingFilters) => ({ ...prevFilters, page }));
    };

    const setPageSize = (pageSize: number): void => {
        setFilters((prevFilters: WatermarkRuleListingFilters) => ({ ...prevFilters, pageSize, page: 1 }));
    };

    const setAirlineName = (airlineName?: string): void => {
        setFilters((prevFilters: WatermarkRuleListingFilters) => ({ ...prevFilters, airlineName, page: 1 }));
    };

    const clearFilters = (): void => {
        setFilters(defaultFilters);
    };

    return {
        filters,
        setAirlineName,
        setPage,
        setPageSize,
        setSort,
        clearFilters
    };
};
